import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Accounting from '../../../../component/accounting';
import AppLayout from '../../../../component/appLayout';
import { getDiscussionData } from '../../../../services/projectServices';
import { useParams } from 'react-router-dom';
import { isEmpty } from '../../../../helpers/common';
import MessagesFeed from '../../../../component/navbarMessageData/messageFeed';
import { rootStore } from '../../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';

const Messages: React.FC = () => {
  // States
  const [selectFile, setSelectFile] = useState<boolean>(false);
  const [attachment, setAttachment] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  //Mobx store
  const { projectStore, workspaceStore } = rootStore;
  const { currentProject, projects, loading, discussionData } = projectStore;
  const { currentWorkspace: workspace } = workspaceStore;
  // Other variables
  const params: { id: string } = useParams();

  // load initial data
  const loadData = useCallback(async () => {
    try {
      setIsLoading(true);
      if (!isEmpty(workspace?.id) && !isEmpty(projects) && params?.id) {
        rootStore.projectStore.setCurrentProject(params?.id);
        // Mark this project's discussion as the open one so background message sync
        // re-projects incoming messages into discussionData in real time.
        rootStore.projectStore.setActiveDiscussionProjectId(params?.id);
        await getDiscussionData(params?.id);
      }
    } catch (e) {
      console.log('error', e);
    } finally {
      setIsLoading(false);
    }
  }, [params?.id, workspace?.id, projects]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    return () => {
      rootStore.projectStore.clearDiscussionData();
    };
  }, []);

  const projectEnvironment = useMemo(
    () => ({ isNavbarMessage: false, isProjectDetail: true, isProjectMessageDetail: true, isMessage: false }),
    []
  );

  const projectFileSelection = useMemo(
    () => ({
      selectFile,
      setSelectFile: (value: boolean) => setSelectFile(value),
      attachment,
      setAttachment
    }),
    [selectFile, attachment]
  );

  return (
    <>
      <AppLayout isMessageBox={true} isOverflowHidden={true}>
        {!selectFile && <Accounting />}
        <MessagesFeed
          loading={loading || isLoading}
          messages={discussionData}
          loadData={loadData}
          currentProject={currentProject}
          projectAllFiles={currentProject?.files || []}
          environment={projectEnvironment}
          fileSelection={projectFileSelection}
        />
      </AppLayout>
    </>
  );
};

export default observer(Messages);
